import { render, staticRenderFns } from "./trading-rules-detail.html?vue&type=template&id=3f650796&scoped=true&external"
import script from "./trading-rules-detail.js?vue&type=script&lang=js&external"
export * from "./trading-rules-detail.js?vue&type=script&lang=js&external"
import style0 from "./trading-rules-detail.scss?vue&type=style&index=0&id=3f650796&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f650796",
  null
  
)

export default component.exports